import OtpInput from "react-otp-input";
import React, { useState, useEffect } from "react";
import "../../../assets/styles/admin/opd.scss";
import { getLocalUrl } from "../../../functions";
import { useParams } from "react-router-dom";
import {
  Input,
  Tooltip,
  Select,
  Button,
  Checkbox,
  DatePicker,
  Form,
  Row,
  Col,
  Upload,
} from "antd";
import { Icon } from "@iconify/react";
import axios from "axios";
import moment from "moment";
import { getFileHostUrl } from "../../../helpers/functions";
import ModalMessage from "../../../components/antd/modalMessage";

import CountryPhoneInput, {
  CountryPhoneInputValue,
  ConfigProvider,
} from "antd-country-phone-input";
import en from "world_countries_lists/data/countries/en/world.json";
import "antd/dist/antd.css";
import "antd-country-phone-input/dist/index.css";

interface Props {
  editValue?: boolean;
  childToParent?: () => void;
}
interface ParamTypes {
  id?: string;
}

const Personal: React.FC<Props> = ({ editValue, childToParent }) => {
  let [form] = Form.useForm();
  const CheckboxGroup = Checkbox.Group;
  const { id } = useParams<ParamTypes>();
  const [fileList, setFileList] = useState<any>([]);
  const [isDisbleList, setIsDisbleList] = useState<any>([]);
  const [check, setCheck] = useState<boolean>(true);
  const [agencyId, setAgencyId] = useState<any>([]);

  const [OtherDer, setOtherDer] = useState<any>([]);
  const [OtherAesthetic, setOtherAesthtic] = useState<any>([]);
  const [OtherCosmetic, setOtherCosmetic] = useState<any>([]);
  const [OtherHair, setOtherHair] = useState<any>([]);
  const [OtherBody, setOtherBody] = useState<any>([]);
  const [other, setOther] = useState<any>([]);

  const [optBranch, setOptBranch] = useState<any>([]);
  const [optAgencies, setOptAgencies] = useState<any>([]);
  const [optPrefix, setOptPrefix] = useState<any>([]);
  const [optGender, setOptGender] = useState<any>([]);
  const [optState, setOptState] = useState<any>([]);
  const [optCity, setOptCity] = useState<any>([]);
  const [optCityCard, setOptCityCard] = useState<any>([]);
  const [optSubCity, setOptSubCity] = useState<any>([]);
  const [optSubCityCard, setOptSubCityCard] = useState<any>([]);
  const [optPostalCode, setOptPostalCode] = useState<any>([]);
  const [optPostalCodeCard, setOptPostalCodeCard] = useState<any>([]);
  const [optCountry, setOptCountry] = useState<any>([]);
  const [optRelationships, setOptRelationships] = useState<any>([]);
  const [optAgencyMembers, setOptAgencyMembers] = useState<any>([]);
  const [optSale, setOptSale] = useState<any>([]);

  const [optHowDidYou, setOptHowDidYou] = useState<any>([]);
  const [optAesthetic, setOptAesthetic] = useState<any>([]);
  const [optCosmetic, setOptCosmetic] = useState<any>([]);
  const [optHair, setOptHair] = useState<any>([]);
  const [optBody, setOptBody] = useState<any>([]);

  const [showModal, setShoeModal] = useState<boolean>(false);
  const [value1, setValue1] = useState<CountryPhoneInputValue>({ short: "TH" });
  const [value2, setValue2] = useState<CountryPhoneInputValue>({ short: "TH" });
  const [value3, setValue3] = useState<CountryPhoneInputValue>({ short: "TH" });
  const [valuePhone1, setPhoneValue1] = useState<any>();
  const [valuePhone2, setPhoneValue2] = useState<any>();
  const [valuePhone3, setPhoneValue3] = useState<any>();
  // check rule
  const [formFirstName, setformFirstName] = useState<string>("");
  const [formListName, setformListName] = useState<string>("");
  const [formNickName, setformNickName] = useState<string>("");
  const [formFirstNameENG, setformFirstNameENG] = useState<string>("");
  const [formListNameENG, setformListNameENG] = useState<string>("");
  const [formNickNameENG, setformNickNameENG] = useState<string>("");

  const [bloodType, setBloodType] = useState<any>([]);

  const dateFormat = "DD-MM-YYYY";
  const saveFormat = "YYYY-MM-DD";

  function onSubmit(values: any) {
    console.log("values =>", values);

    let dataDer = [];
    let dataAesthetic = [];
    let dataCosmetic = [];
    let dataHair = [];
    let dataBody = [];

    if (values["hearAboutDermasters"]) {
      dataDer = values["hearAboutDermasters"].map((item: any) => ({
        _id: item,
      }));
    }
    if (values["otherDer"]) {
      dataDer.push({ _id: values["checkDer"], other: values["otherDer"] });
    }

    if (values["aestheticCenters"]) {
      dataAesthetic = values["aestheticCenters"]?.map((item: any) => ({
        _id: item,
      }));
    }
    if (values["otherAesthetic"]) {
      dataAesthetic.push({
        _id: values["checkAesthetic"],
        other: values["otherAesthetic"],
      });
    }

    if (values["cosmeticSurgeryCenters"]) {
      dataCosmetic = values["cosmeticSurgeryCenters"]?.map((item: any) => ({
        _id: item,
      }));
    }
    if (values["otherCosmetic"]) {
      dataCosmetic.push({
        _id: values["checkCosmetic"],
        other: values["otherCosmetic"],
      });
    }

    if (values["hairCenters"]) {
      dataHair = values["hairCenters"]?.map((item: any) => ({ _id: item }));
    }
    if (values["otherHair"]) {
      dataHair.push({ _id: values["checkHair"], other: values["otherHair"] });
    }

    if (values["bodyCenters"]) {
      dataBody = values["bodyCenters"]?.map((item: any) => ({ _id: item }));
    }
    if (values["otherBody"]) {
      dataBody.push({ _id: values["chackBody"], other: values["otherBody"] });
    }

    let data = {
      ...values,
      sale: values["personal"],
      address: {
        addressNumber: values["addressNumber"],
        buildingName: values["buildingName"],
        moo: values["moo"],
        soi: values["soi"],
        road: values["road"],
        country: values["country"],
        state: values["state"],
        city: values["city"],
        subCity: values["subCity"],
        postalCode: values["postalCode"],
      },
      isSameAddressIDCard: check,
      emergencyContact: {
        prefix: values["prefixContact"],
        firstName: values["firstNameContact"],
        lastName: values["lastNameContact"],
        relationship: values["relationship"],
        phoneNumber: valuePhone3,
      },
      hearAboutDermasters: dataDer,
      aestheticCenters: dataAesthetic,
      cosmeticSurgeryCenters: dataCosmetic,
      hairCenters: dataHair,
      bodyCenters: dataBody,
    };

    if (!check) {
      let dataV2 = {
        ...data,
        addressCurrent: {
          addressNumber: values["addressNumberPresent"],
          buildingName: values["buildingNamePresent"],
          moo: values["mooPresent"],
          soi: values["soiPresent"],
          road: values["roadPresent"],
          country: values["countryPresent"],
          state: values["statePresent"],
          city: values["cityPresent"],
          subCity: values["subCityPresent"],
          postalCode: values["postalCodePresent"],
        },
      };

      saveData(dataV2);
    } else {
      saveData(data);
    }
  }

  const saveData = async (data: any) => {
    const body = {
      ...data,
      phoneNumbersFirst: valuePhone1,
      phoneNumbersSecond: valuePhone2,
    };
    console.log("body", body);

    await axios.patch(`/member-opd/${id}`, body).then((res) => {
      // console.log(data.uploadImage?.file);
      if (data.uploadImage?.file) {
        uploadProfile(res?.data._id, data.uploadImage);
      } else {
        setShoeModal(!showModal);
      }
    });
  };

  const uploadProfile = async (id: any, upload: any) => {
    try {
      if (upload) {
        const fmData = new FormData();
        const config = {
          headers: { "content-type": "multipart/form-data" },
        };
        fmData.append("file", upload?.fileList[0]?.originFileObj);
        await axios.post(`/member-opd/upload-profile/${id}`, fmData, config);
        setShoeModal(!showModal);
      } else {
        setShoeModal(!showModal);
      }
    } catch (error) {}
  };

  const getPersonal = async () => {
    await axios.get(`/member-opd/${id}`).then((res) => {
      console.log("res =>", res.data);
      let data = res?.data;

      setAgencyId(data?.agency);
      const imageUrl = getFileHostUrl(res?.data?.photoURL);
      console.log("imageUrl =>", imageUrl);
      setFileList([
        {
          uid: "-1",
          name: data?.photoURL,
          status: "done",
          response: '{"status": "success"}',
          url: imageUrl,
        },
      ]);

      const hearAboutDer = data?.hearAboutDermasters?.filter(
        (x: any) => x.other === null
      );
      const otherDer = data?.hearAboutDermasters?.find(
        (x: any) => x.other !== null
      );
      if (otherDer) {
        form.setFieldsValue({
          otherDer: otherDer?.other,
          checkDer: otherDer?._id,
        });
        setOther({ ...other, otherDer: true });
      }
      if (hearAboutDer) {
        let code = [];
        for (let i = 0; i < hearAboutDer?.length; i++) {
          code.push(hearAboutDer[i]?._id);
        }
        form.setFieldsValue({
          hearAboutDermasters: code,
        });
      }

      const aesthetic = data?.aestheticCenters?.filter(
        (x: any) => x.other === null
      );
      const otherAesthetic = data?.aestheticCenters?.find(
        (x: any) => x.other !== null
      );
      if (otherAesthetic) {
        form.setFieldsValue({
          otherAesthetic: otherAesthetic?.other,
          checkAesthetic: otherAesthetic?._id,
        });
        setOther({ ...other, otherAesthetic: true });
      }
      if (aesthetic) {
        let code = [];
        for (let i = 0; i < aesthetic?.length; i++) {
          code.push(aesthetic[i]?._id);
        }
        form.setFieldsValue({
          aestheticCenters: code,
        });
      }

      const cosmetic = data?.cosmeticSurgeryCenters?.filter(
        (x: any) => x.other === null
      );
      const otherCosmetic = data?.cosmeticSurgeryCenters?.find(
        (x: any) => x.other !== null
      );
      if (otherCosmetic) {
        form.setFieldsValue({
          otherCosmetic: otherCosmetic?.other,
          checkCosmetic: otherCosmetic?._id,
        });
        setOther({ ...other, otherCosmetic: true });
      }
      if (cosmetic) {
        let code = [];
        for (let i = 0; i < cosmetic?.length; i++) {
          code.push(cosmetic[i]?._id);
        }
        form.setFieldsValue({
          cosmeticSurgeryCenters: code,
        });
      }

      const hair = data?.hairCenters?.filter((x: any) => x.other === null);
      const otherHair = data?.hairCenters?.find((x: any) => x.other !== null);
      if (otherHair) {
        form.setFieldsValue({
          otherHair: otherHair?.other,
          checkHair: otherHair?._id,
        });
        setOther({ ...other, otherHair: true });
      }
      if (hair) {
        let code = [];
        for (let i = 0; i < hair?.length; i++) {
          code.push(hair[i]?._id);
        }
        form.setFieldsValue({
          hairCenters: code,
        });
      }

      const body = data?.bodyCenters?.filter((x: any) => x.other === null);
      const otherBody = data?.bodyCenters?.find((x: any) => x.other !== null);
      if (otherBody) {
        form.setFieldsValue({
          otherBody: otherBody?.other,
          chackBody: otherBody?._id,
        });
        setOther({ ...other, otherBody: true });
      }
      if (body) {
        let code = [];
        for (let i = 0; i < body?.length; i++) {
          code.push(body[i]?._id);
        }
        form.setFieldsValue({
          bodyCenters: code,
        });
      }
      if (data?.phoneNumbersFirst?.phone) {
        setValue1(data?.phoneNumbersFirst);
      }
      if (data?.phoneNumbersSecond?.phone) {
        setValue2(data?.phoneNumbersSecond);
      }
      if (data?.emergencyContact?.phoneNumber?.phone) {
        setValue3(data?.emergencyContact?.phoneNumber);
      }

      setformFirstName(data?.firstName);
      setformListName(data?.lastName);
      setformNickName(data?.nickName);
      setformFirstNameENG(data?.firstNameEN);
      setformListNameENG(data?.lastNameEN);
      setformNickNameENG(data?.nickNameEN);

      form.setFieldsValue({
        uploadImage: data?.photoURL,
        codeCN: data?.code,
        branch: data?.branch,
        date: moment(data?.date),
        agency: data?.agency,
        agencyMember: data?.agencyMember,
        personal: data?.sale,
        prefix: data?.prefix,
        firstName: data?.firstName,
        lastName: data?.lastName,
        nickName: data?.nickName,
        firstNameEN: data?.firstNameEN,
        middleNameEN: data?.middleNameEN,
        lastNameEN: data?.lastNameEN,
        nickNameEN: data?.nickNameEN,
        birthDate: moment(data?.birthDate),
        nationality: data?.nationality,
        bloodtype: data?.bloodtype,
        race: data?.race,
        idCard: data?.idCard,
        passportId: data?.passportId,
        companyRegisterNo: data?.companyRegisterNo,
        gender: data?.gender,
        height: data?.height,
        weight: data?.weight,
        bloodPressure: data?.bloodPressure,
        email: data?.email,
        lineId: data?.lineId,
        addressNumber: data?.address?.addressNumber,
        buildingName: data?.address?.buildingName,
        moo: data?.address?.moo,
        soi: data?.address?.soi,
        road: data?.address?.road,
        country: data?.address?.country,
        state: data?.address?.state,
        city: data?.address?.city,
        subCity: data?.address?.subCity,
        postalCode: data?.address?.postalCode,
        allergyHistory: data?.allergyHistory,
        underlyingDisease: data?.underlyingDisease,
        whereGotTreatment: data?.whereGotTreatment,
        prefixContact: data?.emergencyContact?.prefix,
        firstNameContact: data?.emergencyContact?.firstName,
        lastNameContact: data?.emergencyContact?.lastName,
        relationship: data?.emergencyContact?.relationship,
        // phoneNumberContact: data?.emergencyContact?.phoneNumber,
      });

      setHowOld(data?.birthDate);
      getCities(data?.address?.state, "city");
      getSubCities(data?.address?.city, "subCity");
      getPostalCode(data?.address?.city, "postalCode");
      setCheck(data?.isSameAddressIDCard);
      getPersonalList("");
      getAgencyMembers("", data?.agency);

      if (!data?.isSameAddressIDCard) {
        form.setFieldsValue({
          addressNumberPresent: data?.addressCurrent?.addressNumber,
          buildingNamePresent: data?.addressCurrent?.buildingName,
          mooPresent: data?.addressCurrent?.moo,
          soiPresent: data?.addressCurrent?.soi,
          roadPresent: data?.addressCurrent?.road,
          countryPresent: data?.addressCurrent?.country,
          statePresent: data?.addressCurrent?.state,
          cityPresent: data?.addressCurrent?.city,
          subCityPresent: data?.addressCurrent?.subCity,
          postalCodePresent: data?.addressCurrent?.postalCode,
        });
        getCities(data?.addressCurrent?.state, "cityCard");
        getSubCities(data?.addressCurrent?.city, "subCityCard");
        getPostalCode(data?.addressCurrent?.city, "postalCodeCard");
      }
    });
  };
  const getBranch = async () => {
    await axios.get(`/branches`).then((res) => {
      let data = res?.data?.data;
      const code = [];

      for (let i = 0; i < data?.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setOptBranch(code);
    });
  };
  const getAgencies = async (search: any) => {
    let searchData = search ? `?search=${search}` : "";
    await axios.get(`/agencies${searchData}`).then((res) => {
      let data = res?.data?.data;
      const code = [];
      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setOptAgencies(code);
    });
  };
  const getAgencyMembers = async (search: any, agency: any) => {
    let searchData = search ? `&search=${search}` : "";
    await axios
      .get(`/agencies/members?agencyId=${agency}${searchData}`)
      .then((res) => {
        let data = res?.data?.data;
        const code = [];

        for (let i = 0; i < data.length; i++) {
          code.push(
            <Select.Option value={data[i]?._id} key={data[i]?._id}>
              {data[i]?.code} {data[i]?.name}
            </Select.Option>
          );
        }

        setOptAgencyMembers(code);
      });
  };
  const getPersonalList = async (search: any) => {
    let searchData = search ? `?search=${search}` : "";
    await axios.get(`/users${searchData}`).then((res) => {
      let data = res?.data?.data;
      const code = [];
      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.code} {data[i]?.displayName}
          </Select.Option>
        );
      }
      setOptSale(code);
    });
  };
  const getPrefixes = async () => {
    await axios.get(`/prefixes`).then((res) => {
      let data = res?.data?.data;
      const code = [];

      for (let i = 0; i < data?.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setOptPrefix(code);
    });
  };
  const setHowOld = async (values: any) => {
    if (values) {
      let difference = moment().diff(values);
      let duration = moment.duration(difference);
      form.setFieldsValue({
        year: duration.years(),
        day: duration.days(),
        month: duration.months(),
      });
    } else {
      form.setFieldsValue({
        year: "",
        day: "",
        month: "",
      });
    }
  };
  const getGender = async () => {
    const gender = await axios.get(`/genders`);
    let data = [];
    for (let i = 0; i < gender?.data?.data.length; i++) {
      data.push(
        <Select.Option
          value={gender?.data?.data[i]?._id}
          key={gender?.data?.data[i]?._id}
        >
          {gender?.data?.data[i]?.name}
        </Select.Option>
      );
    }
    setOptGender(data);
  };
  const getStateThai = async () => {
    await axios.get(`/states`).then((res) => {
      let data = res?.data?.data;
      const province = [];
      for (let i = 0; i < data.length; i++) {
        province.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setOptState(province);
    });
  };
  const getCities = async (id: any, state: any) => {
    await axios.get(`/cities?stateId=${id}`).then((res) => {
      let data = res?.data?.data;
      const city = [];

      for (let i = 0; i < data.length; i++) {
        city.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }

      if (state === "city") {
        setOptCity(city);
      } else if (state === "cityCard") {
        setOptCityCard(city);
      }
    });
  };
  const getSubCities = async (id: any, state: any) => {
    await axios.get(`/sub-cities?cityId=${id}`).then((res) => {
      let data = res?.data?.data;
      const subCity = [];
      for (let i = 0; i < data.length; i++) {
        subCity.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      if (state === "subCity") {
        setOptSubCity(subCity);
      } else if (state === "subCityCard") {
        setOptSubCityCard(subCity);
      }
    });
  };
  const getPostalCode = async (id: any, state: any) => {
    await axios.get(`/postal-codes?cityId=${id}`).then((res) => {
      let data = res?.data?.data;
      const code = [];
      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      if (state === "postalCode") {
        setOptPostalCode(code);
      } else if (state === "postalCodeCard") {
        setOptPostalCodeCard(code);
      }
    });
  };
  const getCountry = async () => {
    await axios.get(`/countries`).then((res) => {
      let data = res?.data?.data;
      const code = [];
      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setOptCountry(code);
    });
  };
  const getRelationships = async () => {
    await axios.get(`/relationships`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      for (let i = 0; i < data.length; i++) {
        code.push(
          <Select.Option value={data[i]?._id} key={data[i]?._id}>
            {data[i]?.name}
          </Select.Option>
        );
      }
      setOptRelationships(code);
    });
  };
  const getHowDidYou = async () => {
    await axios.get(`/hear-about-dermasters`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      let check = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        check.push({ label: other?.name, value: other?._id });
        setOtherDer(check);
      }
      setOptHowDidYou(code);
    });
  };
  const getAestheticCenter = async () => {
    await axios.get(`/aesthetic-centers`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      let check = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        check.push({ label: other?.name, value: other?._id });
        setOtherAesthtic(check);
      }
      setOptAesthetic(code);
    });
  };
  const getCosmeticSurgeryCenter = async () => {
    await axios.get(`/cosmetic-surgery-centers`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      let check = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        check.push({ label: other?.name, value: other?._id });
        setOtherCosmetic(check);
      }
      setOptCosmetic(code);
    });
  };
  const getHairCenter = async () => {
    await axios.get(`/hair-centers`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      let check = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        check.push({ label: other?.name, value: other?._id });
        setOtherHair(check);
      }
      setOptHair(code);
    });
  };
  const getBodyCente = async () => {
    await axios.get(`/body-centers`).then((res) => {
      let data = res?.data?.data;
      let code = [];
      let check = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i]?.code !== "other") {
          code.push({ label: data[i]?.name, value: data[i]?._id });
        }
      }
      const other = data.find((x: any) => x.code === "other");
      if (other) {
        check.push({ label: other?.name, value: other?._id });
        setOtherBody(check);
      }
      setOptBody(code);
    });
  };
  const onPreview = (file: any) => {
    console.log("file", file);
    let url = "";
    if (file?.url !== "") {
      url = getLocalUrl(file?.url);
    } else {
      url = getFileHostUrl(file?.name);
    }
    console.log("url", url);
    window.open(url, "_blank");
  };
  const onFileInputChange = (e: any) => {
    const { originFileObj } = e.file;

    const url = getLocalUrl(originFileObj);
    if (e.file.status !== "removed") {
      setFileList([
        {
          uid: "1",
          name: e?.file?.name,
          url: url,
        },
      ]);
    } else {
      form.setFieldsValue({ uploadImage: null });
      setFileList([]);
    }
  };
  const onKeydownCheck = (eveb: KeyboardEvent) => {
    console.log("e event", eveb.which);
    if (eveb.which !== 8) {
      eveb.preventDefault();
      // message.error("Please Input Max 10 ");
    }
  };

  const getBloodType = () => {
    const BType = [
      {
        _id: "A+",
        name: "A+",
      },
      {
        _id: "A-",
        name: "A-",
      },
      {
        _id: "B+",
        name: "B+",
      },
      {
        _id: "B-",
        name: "B-",
      },
      {
        _id: "AB+",
        name: "AB+",
      },
      {
        _id: "AB-",
        name: "AB-",
      },
      {
        _id: "O+",
        name: "O+",
      },
      {
        _id: "O-",
        name: "O-",
      },
    ];
    const bloodType = [];

    for (let i = 0; i < BType?.length; i++) {
      bloodType.push(
        <Select.Option value={BType[i]?._id} key={BType[i]?._id}>
          {BType[i]?.name}
        </Select.Option>
      );
    }

    setBloodType(bloodType);
  };
  const checkValue1 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue1(body);
      }, 200);
    }
  };
  const checkValue2 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue2(body);
      }, 200);
    }
  };
  const checkValue3 = (value: any) => {
    // console.log("value=>>", value);
    if (value?.phone) {
      setTimeout(() => {
        const setnumber =
          value?.phone.substring(0, 1) === "0"
            ? value?.phone.substring(1)
            : value?.phone;
        const body = {
          phone: setnumber,
          code: value.code,
          short: value.short,
        };
        // console.log(body);
        setPhoneValue3(body);
      }, 200);
    }
  };

  useEffect(() => {
    getPersonal();
    getBranch();
    getAgencies("");
    getPrefixes();
    getGender();
    getStateThai();
    getCountry();
    getRelationships();
    getHowDidYou();
    getAestheticCenter();
    getCosmeticSurgeryCenter();
    getHairCenter();
    getBodyCente();
    getBloodType();
  }, []);
  useEffect(() => {
    if (showModal) {
      setShoeModal(false);
    }
  }, [editValue]);

  return (
    <div>
      <Form form={form} onFinish={onSubmit}>
        <div
          className="create-page create-opd"
          style={{ padding: "35px 50px" }}
        >
          <Row gutter={[16, 16]}>
            <Col span={8}>
              <div className="heading">
                <p>รหัสลูกค้า/CN</p>
              </div>
              <Form.Item name="codeCN">
                <Input disabled />
              </Form.Item>
            </Col>
            <Col span={8}>
              <div className="heading">
                <p>สาขา/Branch</p>
              </div>
              <Form.Item
                name="branch"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select className="col-12" showArrow={false} disabled>
                  {optBranch}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <div className="heading">
                <p>วันที่สมัคร/Date</p>
              </div>
              <Form.Item name="date">
                <DatePicker
                  inputReadOnly
                  disabled
                  format={dateFormat}
                  disabledDate={(d) => !d || d.isAfter(moment())}
                  style={{
                    height: "auto",
                    width: "100%",
                    border: "none",
                    borderRadius: "0px",
                    borderBottom: "1px solid #d9d9d9",
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} style={{ marginTop: "20px" }}>
            <Col span={8}>
              <div className="heading">
                <p>หน่วยงาน/Agency</p>
              </div>
              <Form.Item
                name="agency"
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  disabled={editValue}
                  className="col-12 search-one"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  showSearch
                  onSearch={getAgencies}
                  filterOption={false}
                  onChange={(e) => {
                    setAgencyId(e);
                  }}
                >
                  {optAgencies}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8} style={{ paddingTop: "25.4px" }}>
              <Form.Item
                name="agencyMember"
                rules={[
                  {
                    required: false,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  showSearch
                  className="col-12 search-one"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  disabled={editValue}
                  filterOption={false}
                  onSearch={(e) => {
                    getAgencyMembers(e, agencyId);
                  }}
                >
                  {optAgencyMembers}
                </Select>
              </Form.Item>
            </Col>
            <Col span={8}>
              <div className="heading">
                <p>พนักงานขาย/Sale</p>
              </div>
              <Form.Item
                name="personal"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  showSearch
                  className="col-12 search-one"
                  filterOption={false}
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  disabled={editValue}
                  onSearch={getPersonal}
                >
                  {optSale}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <div className="title-header">
            <h3>Personal Information</h3>
            <Row gutter={[16, 16]} style={{ marginLeft: "0" }}>
              <Col span={6} className="pick-img" style={{ paddingLeft: "0" }}>
                <Form.Item name="uploadImage">
                  <Upload
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={onPreview}
                    showUploadList={{ showRemoveIcon: !editValue }}
                    onChange={(e) => {
                      onFileInputChange(e);
                    }}
                    customRequest={({ onSuccess }: any) => {
                      onSuccess();
                    }}
                    accept="image/*"
                  >
                    {fileList?.length < 1 && (
                      <>
                        <div className="icon-upload">
                          <Icon
                            icon="bxs:image-add"
                            width="1.5rem"
                            height="1.5rem"
                            style={{ marginLeft: "5px" }}
                          />
                        </div>
                      </>
                    )}
                  </Upload>
                </Form.Item>
              </Col>
              <Col
                span={18}
                style={{ justifyContent: "space-between", paddingRight: "0" }}
              >
                <Row gutter={[16, 16]} className="data-personal">
                  <Col span={8} style={{ paddingLeft: 0 }}>
                    <div className="heading">
                      <p>คำนำหน้าชื่อ/TITLE</p>
                    </div>
                    <Form.Item
                      name="prefix"
                      rules={[
                        {
                          required: true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Select
                        className="col-12"
                        suffixIcon={
                          <Icon icon="ant-design:caret-down-filled" />
                        }
                        disabled={editValue}
                      >
                        {optPrefix}
                      </Select>
                    </Form.Item>
                  </Col>
                </Row>
                <Row
                  gutter={[16, 16]}
                  className="data-personal"
                  style={{ marginTop: "0.5rem" }}
                >
                  <Col span={8} style={{ paddingLeft: 0 }}>
                    <div className="heading">
                      <p>ชื่อ/NAME*</p>
                    </div>
                    <Form.Item
                      name="firstName"
                      rules={[
                        {
                          required: formFirstNameENG !== "" ? false : true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input
                        disabled={editValue}
                        onChange={(e) => {
                          setformFirstName(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={8} style={{ paddingLeft: 0 }}>
                    <div className="heading">
                      <p>นามสกุล/SURNAME*</p>
                    </div>
                    <Form.Item
                      name="lastName"
                      rules={[
                        {
                          required: formListNameENG !== "" ? false : true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input
                        disabled={editValue}
                        onChange={(e) => {
                          setformListName(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                  <Col
                    span={8}
                    style={{ paddingLeft: 0, paddingRight: "16px" }}
                  >
                    <div className="heading">
                      <p>ชื่อเล่น/NICKNAME</p>
                    </div>
                    <Form.Item
                      name="nickName"
                      rules={[
                        {
                          required: formNickNameENG !== "" ? false : true,
                          message: "กรุณากรอกข้อมูล!",
                        },
                      ]}
                    >
                      <Input
                        disabled={editValue}
                        onChange={(e) => {
                          setformNickName(e.target.value);
                        }}
                      />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>

          <Row
            gutter={[16, 16]}
            className="data-personal"
            style={{ marginTop: "0.5rem" }}
          >
            <Col span={6}>
              <div className="heading">
                <p>NAME</p>
              </div>
              <Form.Item
                name="firstNameEN"
                rules={[
                  {
                    required: formFirstName !== "" ? false : true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input
                  disabled={editValue}
                  onChange={(e) => {
                    setformFirstNameENG(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>MIDDLE NAME</p>
              </div>
              <Form.Item name="middleNameEN">
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>SURNAME</p>
              </div>
              <Form.Item
                name="lastNameEN"
                rules={[
                  {
                    required: formListName !== "" ? false : true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input
                  disabled={editValue}
                  onChange={(e) => {
                    setformListNameENG(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>NICKNAME</p>
              </div>
              <Form.Item
                name="nickNameEN"
                rules={[
                  {
                    required: formNickName !== "" ? false : true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input
                  disabled={editValue}
                  onChange={(e) => {
                    setformNickNameENG(e.target.value);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} className="data-personal">
            <Col span={6}>
              <div className="heading">
                <p>BIRTH DATE</p>
              </div>
              <Form.Item
                name="birthDate"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <DatePicker
                  inputReadOnly
                  format={dateFormat}
                  style={{
                    height: "auto",
                    width: "100%",
                    border: "none",
                    borderRadius: "0px",
                    borderBottom: "1px solid #d9d9d9",
                  }}
                  disabled={editValue}
                  onChange={setHowOld}
                  disabledDate={(d) => !d || d.isAfter(moment())}
                />
              </Form.Item>
            </Col>
            <Col span={2}>
              <div className="heading">
                <p>YEAR</p>
              </div>
              <Form.Item name="year">
                <Input style={{ textAlign: "center" }} disabled />
              </Form.Item>
            </Col>
            <Col span={2}>
              <div className="heading">
                <p>MONTH</p>
              </div>
              <Form.Item name="month">
                <Input style={{ textAlign: "center" }} disabled />
              </Form.Item>
            </Col>
            <Col span={2}>
              <div className="heading">
                <p>DAY</p>
              </div>
              <Form.Item name="day">
                <Input style={{ textAlign: "center" }} disabled />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>สัญชาติ/NATIONALITY</p>
              </div>
              <Form.Item
                name="nationality"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>เชื้อชาติ/RACE</p>
              </div>
              <Form.Item
                name="race"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} className="data-personal">
            <Col span={12}>
              <div className="heading">
                <p>IDENTITY NO.*</p>
              </div>
              <Form.Item
                name="idCard"
                // rules={[
                //   {
                //     required: true,
                //     message: "กรุณากรอกข้อมูล!",
                //   },
                // ]}
              >
                <OtpInput
                  inputStyle={{
                    border: "1px solid #909090",
                    borderRadius: "8px",
                    width: "25px",
                    height: "25px",
                    fontSize: "16px",
                    color: "#333333",
                    fontWeight: "500",
                  }}
                  isInputNum
                  numInputs={13}
                  separator={<span style={{ width: "5px" }}></span>}
                  focusStyle={{
                    border: "1px solid #909090",
                    outline: "none",
                  }}
                  isDisabled={editValue}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>PASSPORT NO.</p>
              </div>
              <Form.Item name="passportId">
                <Input
                  disabled={editValue}
                  onKeyDown={(e: any) => {
                    if (e.target.value.length >= 10) {
                      onKeydownCheck(e);
                    }
                  }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              {/* <div className="heading">
                <p>COMPANY REGISTRATION NO.</p>
              </div>
              <Form.Item name="companyRegisterNo">
                <Input disabled={editValue} />
              </Form.Item> */}
            </Col>
          </Row>

          <Row gutter={[16, 16]} className="data-personal">
            <Col span={6}>
              <div className="heading">
                <p>GENDER*</p>
              </div>
              <Form.Item
                name="gender"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  disabled={editValue}
                  className="col-12"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                >
                  {optGender}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>HEIGHT (cm.)</p>
              </div>
              <Form.Item
                name="height"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input type="number" disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>WEIGHT (kg.)</p>
              </div>
              <Form.Item
                name="weight"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input type="number" disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>BLOOD TYPE*</p>
              </div>
              <Form.Item name="bloodtype">
                <Select
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  // filterOption={(input: any, option: any) =>
                  //   option.children
                  //     .toLowerCase()
                  //     .indexOf(input.toLowerCase()) >= 0
                  // }
                  // showSearch
                  disabled={editValue}
                >
                  {bloodType}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} className="data-personal">
            <Col span={6}>
              {/* <div className="heading">
                <p>MOBILE NO.*</p>
              </div> */}

              <Form.Item
                name="phoneNumbersFirst"
                className="select-countrycode"
              >
                <ConfigProvider locale={en}>
                  <CountryPhoneInput
                    style={{
                      marginTop: "21px",
                      marginBottom: "50px",
                      padding: 0,
                    }}
                    type="number"
                    value={value1}
                    onChange={(v: any) => {
                      setValue1(v);
                      if (editValue === false) {
                        checkValue1(v);
                      }
                    }}
                    disabled={editValue}
                    onKeyDown={(e: any) => {
                      if (e.target.value.length >= 10) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </ConfigProvider>
              </Form.Item>
            </Col>
            <Col span={6}>
              {/* <div className="heading">
                <p>MOBILE NO.*</p>
              </div> */}

              <Form.Item
                name="phoneNumbersSecond"
                className="select-countrycode"
              >
                <ConfigProvider locale={en}>
                  <CountryPhoneInput
                    style={{
                      marginTop: "21px",
                      marginBottom: "50px",
                      padding: 0,
                    }}
                    type="number"
                    value={value2}
                    onChange={(v: any) => {
                      setValue2(v);
                      if (editValue === false) {
                        checkValue2(v);
                      }
                    }}
                    disabled={editValue}
                    onKeyDown={(e: any) => {
                      if (e.target.value.length >= 10) {
                        onKeydownCheck(e);
                      }
                    }}
                  />
                </ConfigProvider>
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>E-MAIL</p>
              </div>
              <Form.Item
                name="email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "กรุณากรอกข้อมูลอีเมลให้ถูกต้อง!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>LINE ID</p>
              </div>
              <Form.Item
                name="lineId"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
          </Row>

          <div className="title-header">
            <h3 style={{ margin: "3px 0px 30px" }}>Address Information</h3>
          </div>
          <h5>Address as per ID Card (ที่อยู่ตามบัตรประชาชน)</h5>

          <Row
            gutter={[16, 16]}
            className="data-personal"
            style={{ marginTop: "30px" }}
          >
            <Col span={6}>
              <div className="heading">
                <p>Number/เลขที่*</p>
              </div>
              <Form.Item
                name="addressNumber"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>Building/ชื่ออาคาร</p>
              </div>
              <Form.Item
                name="buildingName"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>Village No./หมู่ที่</p>
              </div>
              <Form.Item
                name="moo"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>Lane/ซอย</p>
              </div>
              <Form.Item
                name="soi"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} className="data-personal">
            <Col span={6}>
              <div className="heading">
                <p>Road/ถนน</p>
              </div>
              <Form.Item
                name="road"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Input disabled={editValue} />
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>Province/จังหวัด*</p>
              </div>
              <Form.Item
                name="state"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  className="col-12"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  disabled={editValue}
                  onChange={(e) => {
                    form.setFieldsValue({
                      city: null,
                      subCity: null,
                      postalCode: null,
                    });
                    getCities(e, "city");
                    setIsDisbleList({
                      ...isDisbleList,
                      isCity: true,
                      isSubCity: false,
                      isPostalCode: false,
                    });
                  }}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optState}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>District/เขต/อำเภอ*</p>
              </div>
              <Form.Item
                name="city"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  className="col-12"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  disabled={
                    editValue ? true : isDisbleList?.isCity ? false : true
                  }
                  onChange={(e) => {
                    form.setFieldsValue({
                      subCity: null,
                      postalCode: null,
                    });
                    setIsDisbleList({
                      ...isDisbleList,
                      isSubCity: true,
                      isPostalCode: true,
                    });
                    getSubCities(e, "subCity");
                    getPostalCode(e, "postalCode");
                  }}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optCity}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>Sub-district/แขวง/ตำบล*</p>
              </div>
              <Form.Item
                name="subCity"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  className="col-12"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  disabled={
                    editValue ? true : isDisbleList?.isSubCity ? false : true
                  }
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optSubCity}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={[16, 16]} className="data-personal">
            <Col span={6}>
              <div className="heading">
                <p>Postal Code/รหัสไปรษณีย์*</p>
              </div>
              <Form.Item
                name="postalCode"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  className="col-12"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  disabled={
                    editValue ? true : isDisbleList?.isPostalCode ? false : true
                  }
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optPostalCode}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <div className="heading">
                <p>Country/ประเทศ*</p>
              </div>
              <Form.Item
                name="country"
                rules={[
                  {
                    required: true,
                    message: "กรุณากรอกข้อมูล!",
                  },
                ]}
              >
                <Select
                  className="col-12"
                  suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                  disabled={editValue}
                  filterOption={(input: any, option: any) =>
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  showSearch
                >
                  {optCountry}
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <h5 style={{ marginTop: "30px" }}>
            Present Address (ที่อยู่ปัจจุบัน)
          </h5>

          <Checkbox
            checked={check}
            style={{ marginTop: "10px" }}
            onChange={(e) => {
              setCheck(e.target.checked);
            }}
            disabled={editValue}
          >
            เหมือนที่อยู่ตามบัตรประชาชน/Same as the address on the ID card
          </Checkbox>

          {!check && (
            <>
              <Row
                gutter={[16, 16]}
                className="data-personal"
                style={{ marginTop: "30px" }}
              >
                <Col span={6}>
                  <div className="heading">
                    <p>Number/เลขที่*</p>
                  </div>
                  <Form.Item
                    name="addressNumberPresent"
                    rules={[
                      {
                        required: !check,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input disabled={editValue} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <div className="heading">
                    <p>building/ชื่ออาคาร</p>
                  </div>
                  <Form.Item name="buildingNamePresent">
                    <Input disabled={editValue} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <div className="heading">
                    <p>Moo/หมู่ที่</p>
                  </div>
                  <Form.Item name="mooPresent">
                    <Input disabled={editValue} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <div className="heading">
                    <p>Lane/ซอย</p>
                  </div>
                  <Form.Item name="soiPresent">
                    <Input disabled={editValue} />
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="data-personal">
                <Col span={6}>
                  <div className="heading">
                    <p>Road/ถนน</p>
                  </div>
                  <Form.Item name="roadPresent">
                    <Input disabled={editValue} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <div className="heading">
                    <p>Province/จังหวัด*</p>
                  </div>
                  <Form.Item
                    name="statePresent"
                    rules={[
                      {
                        required: !check,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Select
                      disabled={editValue}
                      className="col-12"
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      onChange={(e) => {
                        form.setFieldsValue({
                          cityPresent: null,
                          subCityPresent: null,
                          postalCodePresent: null,
                        });
                        getCities(e, "cityCard");
                        setIsDisbleList({
                          ...isDisbleList,
                          isCityPresent: true,
                          isSubCityPresent: false,
                          isPostalCodePresent: false,
                        });
                      }}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {optState}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <div className="heading">
                    <p>District/เขต/อำเภอ*</p>
                  </div>
                  <Form.Item
                    name="cityPresent"
                    rules={[
                      {
                        required: !check,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Select
                      className="col-12"
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      disabled={
                        editValue
                          ? true
                          : isDisbleList?.isCityPresent
                          ? false
                          : true
                      }
                      onChange={(e) => {
                        form.setFieldsValue({
                          subCityPresent: null,
                          postalCodePresent: null,
                        });
                        setIsDisbleList({
                          ...isDisbleList,
                          isSubCityPresent: true,
                          isPostalCodePresent: true,
                        });
                        getSubCities(e, "subCityCard");
                        getPostalCode(e, "postalCodeCard");
                      }}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {optCityCard}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <div className="heading">
                    <p>Sub-district/แขวง/ตำบล*</p>
                  </div>
                  <Form.Item
                    name="subCityPresent"
                    rules={[
                      {
                        required: !check,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Select
                      className="col-12"
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      disabled={
                        editValue
                          ? true
                          : isDisbleList?.isSubCityPresent
                          ? false
                          : true
                      }
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {optSubCity}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={[16, 16]} className="data-personal">
                <Col span={6}>
                  <div className="heading">
                    <p>Postal Code/รหัสไปรษณีย์*</p>
                  </div>
                  <Form.Item
                    name="postalCodePresent"
                    rules={[
                      {
                        required: !check,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Select
                      className="col-12"
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      disabled={
                        editValue
                          ? true
                          : isDisbleList?.isPostalCodePresent
                          ? false
                          : true
                      }
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {optPostalCode}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <div className="heading">
                    <p>Country/ประเทศ*</p>
                  </div>
                  <Form.Item
                    name="countryPresent"
                    rules={[
                      {
                        required: !check,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Select
                      className="col-12"
                      suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                      disabled={editValue}
                      filterOption={(input: any, option: any) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      showSearch
                    >
                      {optCountry}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </>
          )}

          <div className="allergypage-page edit-personal">
            <div className="title-header">
              <h4>Allergy History and Underlying Disease</h4>
            </div>

            <div className="allergy-history">
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <div className="heading">
                    <p>Allergy Surery Center (ประวัติแพ้ยา/เครื่องสำอาง)*</p>
                  </div>
                  <Form.Item
                    name="allergyHistory"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input disabled={editValue} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 16]} style={{ marginTop: "1rem" }}>
                <Col span={24}>
                  <div className="heading">
                    <p>Underlying Disease (โรคประจำตัว)*</p>
                  </div>
                  <Form.Item
                    name="underlyingDisease"
                    rules={[
                      {
                        required: true,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input
                      type="text"
                      disabled={editValue}
                      onChange={(e) => {
                        // setCongenitalDisease(e.target.value);
                        // setUnderLyingErrors(!e.target.value ? true : false);
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </div>

            <Row gutter={[16, 16]}>
              <Col span={24}>
                <div className="heading">
                  <p>Medical record (เคยรักษาที่ไหนมาก่อน)</p>
                </div>
                <Form.Item name="whereGotTreatment">
                  <Input disabled={editValue} />
                </Form.Item>
              </Col>
            </Row>

            <div className="title-header">
              <h4 style={{ margin: "40px 0 0" }}>Emergency Contact</h4>
            </div>

            <Row
              gutter={[16, 16]}
              className="emergency-contact"
              style={{ marginTop: "30px" }}
            >
              <Col span={6}>
                <div className="heading">
                  <p>คำนำหน้าชื่อ/TITLE</p>
                </div>
                <Form.Item
                  name="prefixContact"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    className="col-12"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    disabled={editValue}
                  >
                    {optPrefix}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={6}>
                <div className="heading">
                  <p>ชื่อ/NAME*</p>
                </div>
                <Form.Item
                  name="firstNameContact"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input disabled={editValue} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <div className="heading">
                  <p>นามสกุล/SURNAME*</p>
                </div>
                <Form.Item
                  name="lastNameContact"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Input disabled={editValue} />
                </Form.Item>
              </Col>
              <Col span={6}>
                <div className="heading">
                  <p>RELATIONSHIP</p>
                </div>
                <Form.Item
                  name="relationship"
                  rules={[
                    {
                      required: true,
                      message: "กรุณากรอกข้อมูล!",
                    },
                  ]}
                >
                  <Select
                    className="col-12"
                    suffixIcon={<Icon icon="ant-design:caret-down-filled" />}
                    disabled={editValue}
                  >
                    {optRelationships}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={[16, 16]} className="emergency-contact">
              <Col span={12}>
                <div className="heading">
                  <p>MOBILE NO.*</p>
                </div>
                <Form.Item
                  name="phoneNumberContact"
                  className="select-countrycode"
                  // rules={[
                  //   {
                  //     required: true,
                  //     message: "กรุณากรอกข้อมูล!",
                  //   },
                  // ]}
                  // className="number-input"
                >
                  <ConfigProvider locale={en}>
                    <CountryPhoneInput
                      style={{ marginBottom: "50px", padding: 0 }}
                      type="number"
                      value={value3}
                      onChange={(v: any) => {
                        setValue3(v);
                        if (editValue === false) {
                          checkValue3(v);
                        }
                      }}
                      disabled={editValue}
                    />
                  </ConfigProvider>
                  {/* <Input
                    type="number"
                    disabled={editValue}
                    onKeyDown={(e: any) => {
                      if (e.target.value.length > 9) {
                        onKeydownCheck(e);
                      }
                    }}
                  /> */}
                </Form.Item>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header" style={{ marginTop: "1rem" }}>
              <h5 style={{ marginTop: "unset" }}>
                How did you hear about Dermaster? (รู้จัก Dermaster จากที่ไหน?)
              </h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "1.5rem" }}
              className="hear-about-der"
            >
              <Col span={24}>
                <Form.Item name="hearAboutDermasters">
                  <CheckboxGroup options={optHowDidYou} disabled={editValue} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Item name="checkDer">
                    <CheckboxGroup
                      options={OtherDer}
                      disabled={editValue}
                      onChange={(e) => {
                        setOther({
                          ...other,
                          otherDer: e.length ? true : false,
                        });
                        form.setFieldsValue({
                          otherDer: null,
                        });
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="otherDer"
                    rules={[
                      {
                        required: other?.otherDer ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input
                      disabled={
                        editValue ? true : other?.otherDer ? false : true
                      }
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5>Aesthetic Center (แผนกผิวพรรณและความงาม)</h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
              className="aesthetic-centers"
            >
              <Col span={24}>
                <Form.Item name="aestheticCenters">
                  <CheckboxGroup options={optAesthetic} disabled={editValue} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Item name="checkAesthetic">
                    <CheckboxGroup
                      options={OtherAesthetic}
                      disabled={editValue}
                      onChange={(e) => {
                        setOther({
                          ...other,
                          otherAesthetic: e.length ? true : false,
                        });
                        form.setFieldsValue({
                          otherAesthetic: null,
                        });
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="otherAesthetic"
                    rules={[
                      {
                        required: other?.otherAesthetic ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input
                      disabled={
                        editValue ? true : other?.otherAesthetic ? false : true
                      }
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5>Cosmetic Surgery Center (แผนกศัลยกรรมความงาม)</h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
              className="cosmetic-surgery-centers"
            >
              <Col span={24}>
                <Form.Item name="cosmeticSurgeryCenters">
                  <CheckboxGroup disabled={editValue} options={optCosmetic} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Item name="checkCosmetic">
                    <CheckboxGroup
                      options={OtherCosmetic}
                      disabled={editValue}
                      onChange={(e) => {
                        setOther({
                          ...other,
                          otherCosmetic: e.length ? true : false,
                        });
                        form.setFieldsValue({
                          otherCosmetic: null,
                        });
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="otherCosmetic"
                    rules={[
                      {
                        required: other?.otherCosmetic ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input
                      disabled={
                        editValue ? true : other?.otherCosmetic ? false : true
                      }
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5>Hair Center (แผนกผม)</h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
              className="hair-centers"
            >
              <Col span={24}>
                <Form.Item name="hairCenters">
                  <CheckboxGroup options={optHair} disabled={editValue} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Item name="checkHair">
                    <CheckboxGroup
                      options={OtherHair}
                      disabled={editValue}
                      onChange={(e) => {
                        setOther({
                          ...other,
                          otherHair: e.length ? true : false,
                        });
                        form.setFieldsValue({
                          otherHair: null,
                        });
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="otherHair"
                    rules={[
                      {
                        required: other?.otherHair ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input
                      disabled={
                        editValue ? true : other?.otherHair ? false : true
                      }
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>

            {/* ----------------------------------------------------------------------------------------------------- */}
            <div className="title-header">
              <h5>Body Center (แผนกรูปร่างและสัดส่วน)</h5>
            </div>

            <Row
              gutter={[16, 16]}
              style={{ marginTop: "10px" }}
              className="body-centers"
            >
              <Col span={24}>
                <Form.Item name="bodyCenters">
                  <CheckboxGroup options={optBody} disabled={editValue} />
                </Form.Item>
              </Col>
              <Col span={24}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Form.Item name="chackBody">
                    <CheckboxGroup
                      options={OtherBody}
                      disabled={editValue}
                      onChange={(e) => {
                        setOther({
                          ...other,
                          otherBody: e.length ? true : false,
                        });
                        form.setFieldsValue({
                          otherBody: null,
                        });
                      }}
                    />
                  </Form.Item>
                  <Form.Item
                    name="otherBody"
                    rules={[
                      {
                        required: other?.otherBody ? true : false,
                        message: "กรุณากรอกข้อมูล!",
                      },
                    ]}
                  >
                    <Input
                      disabled={
                        editValue ? true : other?.otherBody ? false : true
                      }
                    />
                  </Form.Item>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        {!editValue && (
          <>
            {console.log("editValue", editValue)}

            <div className="btn-update">
              <Form.Item colon={false}>
                <Button
                  type="primary"
                  htmlType="submit"
                  // onClick={childToParent}
                >
                  Update
                </Button>
              </Form.Item>
              <ModalMessage
                show={showModal}
                title="แก้ไขผู้ใช้งานเรียบร้อยแล้ว"
                subTitle="User edited successfully."
                path="#"
                status={true}
                onCancel={childToParent}
              />
            </div>
          </>
        )}
      </Form>
    </div>
  );
};
export default Personal;
